import { render, staticRenderFns } from "./InvoiceTable.vue?vue&type=template&id=04359670&scoped=true&"
import script from "./InvoiceTable.vue?vue&type=script&lang=js&"
export * from "./InvoiceTable.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceTable.vue?vue&type=style&index=0&id=04359670&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04359670",
  null
  
)

export default component.exports